import { SignIn, SignUp } from "@clerk/clerk-react";
import { Link } from "@tanstack/react-router";
import styles from "./AuthScreen.module.scss";

type Props = {
  mode: "sign-in" | "sign-up";
  /** Absolute URL to land on once signed in. */
  redirectUrl: string;
};

const COPY = {
  "sign-in": {
    eyebrow: "Welcome back",
    title: (
      <>
        Your invitations are <em>waiting</em>
      </>
    ),
  },
  "sign-up": {
    eyebrow: "Create your account",
    title: (
      <>
        Begin your <em>invitation</em>
      </>
    ),
  },
} as const;

/** Branded in-app auth. Hash routing keeps Clerk's multi-step flow on the current URL. */
export function AuthScreen({ mode, redirectUrl }: Props) {
  const copy = COPY[mode];
  const other = `/${mode === "sign-in" ? "sign-up" : "sign-in"}?redirect_url=${encodeURIComponent(redirectUrl)}`;

  return (
    <div className={styles.screen}>
      <aside className={styles.story}>
        <Link className={styles.brand} to="/" aria-label="Archi home">
          <span className={styles.mark}>A</span>
          <span>ARCHI</span>
        </Link>

        <div className={styles.vignette} aria-hidden="true">
          <div className={styles.envelope}>
            <i className={styles.flap} />
            <span className={styles.seal}>A&amp;D</span>
          </div>
          <div className={styles.card}>
            <small>Together with their families</small>
            <strong>
              Archi <i>&amp;</i> Dhruv
            </strong>
            <span className={styles.rule} />
            <small>14 February 2027</small>
          </div>
        </div>

        <div className={styles.copy}>
          <p className={styles.eyebrow}>{copy.eyebrow}</p>
          <h1>{copy.title}</h1>
          <ul>
            <li>Design your card and envelope</li>
            <li>Send personal links on WhatsApp or email</li>
            <li>See who opened and who's coming</li>
          </ul>
        </div>
      </aside>

      <main className={styles.formSide}>
        <Link className={styles.back} to="/">
          ← Back to home
        </Link>
        <div className={styles.form}>
          {mode === "sign-in" ? (
            <SignIn routing="hash" forceRedirectUrl={redirectUrl} signUpUrl={other} />
          ) : (
            <SignUp routing="hash" forceRedirectUrl={redirectUrl} signInUrl={other} />
          )}
        </div>
      </main>
    </div>
  );
}
